define(function (require) {

    var ViewController = require('web-agent-framework/ViewController');
    var DialogViewController = require('web-agent-viewControllers/DialogViewController');

    ViewController.plugin({
        supportDialogs: true,

        showDialog: function (dialogInfo) {
            if (this.dialogViewController) {
                return; // TODO: decide what to do if we have multiple dialogs popping.
            } else {
                var that = this;
                this.dialogViewController = new DialogViewController({
                    dialogInfo: dialogInfo,
                    okCallback: function () {
                        if (dialogInfo.okCallback) {
                            dialogInfo.okCallback.call(that);
                        }
                        // we dismiss the dialog only after the okCallback to allow it to retrieve data from the dialog (such as in the custom widget dialog)
                        that.dismissDialog();
                    },
                    cancelCallback: function () {
                        that.dismissDialog();
                        if (dialogInfo.cancelCallback) {
                            dialogInfo.cancelCallback.call(that);
                        }
                    },
                    dismissCallback: function () {
                        that.dismissDialog();
                        if (dialogInfo.dismissCallback) {
                            dialogInfo.dismissCallback.call(that);
                        }
                    },
                    xEnabled: dialogInfo.xEnabled,
                    onInitialize: dialogInfo.onInitialize
                });
                var targetView;
                if (dialogInfo.targetView) {
                    targetView = dialogInfo.targetView;
                } else if (dialogInfo.targetSelector) {
                    targetView = this.getFirstElement(dialogInfo.targetSelector);
                } else {
                    targetView = this.view;
                }
                this.addViewController({viewController : this.dialogViewController, target : targetView});
            }
        },

        dismissDialog: function (e) {
            if (!this.dialogViewController) {
                return;
            }
            if (!this.dialogViewController.dismissed) {
                this.dialogViewController.dismissDialog(e);
            }
            if (this.dialogViewController) {
                this.dialogViewController = null;
                delete this.dialogViewController;
            }
        }
    });

    // todo - what to export?

});
